import { style } from 'typestyle'
export const hide = style({ display: 'none' })
